import ArtTypes from '~/constants/types/ArtTypes';
import DesignTypes from '~/constants/types/DesignTypes';
import IconTypes from '~/constants/types/IconTypes';
import NamesAndNumbersTypes from '~/constants/types/NamesAndNumbersTypes';
import TextTypes from '~/constants/types/TextTypes';
import UploadTypes from '~/constants/types/UploadTypes';
import ProductTypes from '~/constants/types/ProductTypes';

export const LIMIT = 30;

export const TYPES = [
  ArtTypes.ADD_ART,
  ArtTypes.CHANGE_SPOT_COLOR,
  ArtTypes.UPDATE_TRANSPARENCY,
  ArtTypes.SWAP,
  TextTypes.ADD_TEXT,
  TextTypes.UPDATE_TEXT,
  TextTypes.UPDATE_OUTLINE,
  TextTypes.UPDATE_EFFECT,
  TextTypes.UPDATE_FONT,
  TextTypes.UPDATE_FONT_HEIGHT,
  NamesAndNumbersTypes.ADD_NAMES,
  NamesAndNumbersTypes.ADD_NUMBERS,
  NamesAndNumbersTypes.ADD_NAMES_AND_NUMBERS,
  IconTypes.ALIGN,
  IconTypes.ALIGN_CENTER,
  IconTypes.ALIGN_MIDDLE,
  IconTypes.ALIGN_LEFT,
  IconTypes.ALIGN_RIGHT,
  IconTypes.ALIGN_TOP,
  IconTypes.ALIGN_BOTTOM,
  IconTypes.BACKWARD,
  IconTypes.CENTER,
  IconTypes.CHANGE_COLOR,
  IconTypes.COPY,
  IconTypes.CROP,
  IconTypes.CUT,
  IconTypes.DISTRIBUTE_HORIZONTAL,
  IconTypes.DISTRIBUTE_VERTICAL,
  IconTypes.DUPLICATE,
  IconTypes.FORWARD,
  IconTypes.MOVE,
  IconTypes.MULTI_ICON_ALIGN,
  IconTypes.REMOVE,
  IconTypes.RESIZE,
  IconTypes.RESTORE,
  IconTypes.ROTATE,
  IconTypes.PASTE,
  IconTypes.UPDATE_HORIZONTAL_FLIP,
  IconTypes.UPDATE_VERTICAL_FLIP,
  IconTypes.UPDATE_SINGLE_COLOR,
  IconTypes.TOGGLE_INVERTED_CLIPART,
  UploadTypes.CHANGE_SPOT_COLOR,
  UploadTypes.RESET_UPLOAD,
  UploadTypes.UPDATE_COLOR_MODE,
  UploadTypes.UPLOAD_COMPLETE,
  UploadTypes.UPLOAD_AND_SWAP,
  DesignTypes.CLEAR_DESIGN_DATA,
  ProductTypes.ADD_PRODUCT,
  ProductTypes.CHANGE_COLOR,
  ProductTypes.DELETE_PRODUCT,
  ProductTypes.SWAP_PRODUCT,
  ProductTypes.REPLACE_PRODUCTS_CART_MODE
];
